import { ProductSettings } from '~/lib';
import { Product } from '~/lib/data-contract/salesforce';
import {
    extractRemainingStockFromText,
    LOW_STOCK_THRESHOLD,
} from '~/lib/salesforce/utilities/product-stock';
import { TNotification } from '~/shared/components/ProductCard/components/Notifications';
import { TProductDetails } from '~/shared/components/ProductCard/ProductCard.definition';
import { TranslateFn } from '~/shared/utils/translation/hooks/useTranslation';

export const createNotifications = (
    product: Product,
    translate: TranslateFn,
    convertPriceToLocale: (price: number) => string,
    frameProductSettings?: ProductSettings,
): TProductDetails['notifications'] => {
    const leftInfo: TNotification = { text: '', type: 'secondary' };
    const rightInfo: TNotification = { text: '', type: 'primary' };
    const minimumShippingCost = product?.c_minimumShippingCost || product?.cust_minimumShippingCost;

    const deliveryDays = product?.c_deliveryDaysText || product?.cust_deliveryDaysText;
    const persuasiveText = product?.c_persuasiveText || product?.cust_persuasiveText;

    if (minimumShippingCost) {
        const cost = parseInt(minimumShippingCost);

        if (cost === 0) {
            leftInfo.text += translate('plp.freeShipping');
        } else if (!isNaN(cost)) {
            // Hide labels if they are explicitly off, otherwise show them.
            if (frameProductSettings?.showFreightPrice === true) {
                leftInfo.text += translate('checkout.freightCostFrom', {
                    amount: convertPriceToLocale(minimumShippingCost),
                });
            }
        }
    }

    if (deliveryDays) {
        leftInfo.text += (leftInfo.text ? ' — ' : '') + deliveryDays;
    }

    const remainingStock = extractRemainingStockFromText(persuasiveText);

    if (remainingStock !== undefined && remainingStock < LOW_STOCK_THRESHOLD) {
        rightInfo.text = translate('pdp.persuasive', { amount: remainingStock.toString() });
    }

    const notifications = [leftInfo, rightInfo].filter((notification) => !!notification.text);

    return notifications;
};
